<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { getStr } from '../../../common/util';
  import Text from '../../common/components/Text.svelte';
  import { generateArrayOfYears } from '../services/pdp-data-services';
  import { rsaBrand, rsaPlateNo, rsaYear } from '../store/pdp_store';

  export let brands;
  const carBrands = brands.map(x => x.name);
  let filteredCarBrand = carBrands;
  const carYear = generateArrayOfYears(9);
  let filteredYear = carYear;

  function validatePlateNo() {
    const specialCharCheck = /[`!@#$%^&*()_+=[\]{};':"\\|,.<>/?~]/;
    if (specialCharCheck.test($rsaPlateNo) === true) {
      $rsaPlateNo = $rsaPlateNo.replace(/[^A-Za-z ]/g, '');
    }
  }
  //label
  const Selectbrand = getStr('extra.pdp.rsa.Selectbrand');
  const Brand = getStr('extra.pdp.rsa.brand');
  const Selectyear = getStr('extra.pdp.rsa.Selectyear');
  const Year = getStr('extra.pdp.rsa.year');
  const PlateNumber = getStr('extra.pdp.rsa.PlateNumber');
  const PlateNumberPlaceholder = getStr('extra.pdp.rsa.PlateNumberPlaceholder');
  const provideCarDetails = getStr('extra.pdp.rsa.provideCarDetails');
  const QuickSearch = getStr('extra.pdp.rsa.quickSearch');

  let carBrandPlaceholder = Selectbrand;
  let yearPlaceholder = Selectyear;
  let openCarDropDown = false;
  let openYearDropDown = false;
  let isCarPlaceholder = true;
  let isYearPlaceholder = true;

  document.onclick = function (e: any) {
    if (e.target.id == 'carBrandDownDrop' || e.target.id == 'carBrandDownDropInput') {
      openCarDropDown = true;
    } else {
      openCarDropDown = false;
    }
    if (e.target.id == 'yearDownDrop' || e.target.id == 'yearDownDropInput') {
      openYearDropDown = true;
    } else {
      openYearDropDown = false;
    }
  };
  const handleCarSelect = e => {
    const carBrandCode = brands.filter(x => x.name == e);
    rsaBrand.set(carBrandCode[0].code);
    carBrandPlaceholder = carBrandCode[0].name;
    isCarPlaceholder = false;
  };
  const handleYearSelect = e => {
    rsaYear.set(e);
    yearPlaceholder = $rsaYear;
    isYearPlaceholder = false;
  };
  const handleClickInsideCarDropDown = () => {
    openCarDropDown = true;
    filteredCarBrand = carBrands;
  };
  const handleClickInsideYearDropDown = () => {
    openYearDropDown = true;
    filteredYear = carYear;
  };
  const filterCarBrand = e => {
    filteredCarBrand = carBrands;
    const letter = e.target.value.toUpperCase();
    if (letter !== '') {
      filteredCarBrand = filteredCarBrand.filter(name => name.includes(letter));
    }
  };
  const filteryear = e => {
    filteredYear = carYear;
    const letter = e.target.value;
    if (letter !== '') {
      filteredYear = filteredYear.filter(name => name.toString().includes(letter));
    }
  };
</script>

{#if brands && brands.length > 0}
  <section class="rsa-detail-section">
    <div class="rsa-detail-title"><Text key={provideCarDetails} /></div>
    <LayoutGrid>
      <Cell spanDevices={{ desktop: 6, tablet: 4, phone: 4 }}>
        <div class="inputHeading">{Brand}</div>
        <div class="brand-selection inputfield-select">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="brandClsDiv" id="carBrandDownDrop" on:click={handleClickInsideCarDropDown}>
            <span class:PlaceholderCls={isCarPlaceholder}> {carBrandPlaceholder}</span>
          </div>
          {#if openCarDropDown}
            <span class="carBrandDownDropList">
              <input
                id="carBrandDownDropInput"
                type="text"
                placeholder={QuickSearch}
                class="brandClsInput"
                on:input={e => filterCarBrand(e)}
              />
              <ul class="dropdown-options">
                <li>{Brand}</li>
                {#each filteredCarBrand as option}
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <li on:click={() => handleCarSelect(option)}>{option}</li>
                {/each}
              </ul>
            </span>
          {/if}
        </div></Cell
      >

      <Cell spanDevices={{ desktop: 6, tablet: 4, phone: 4 }}>
        <div class="inputHeading">{Year}</div>
        <div class="year-selection inputfield-select">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="brandClsDiv" id="yearDownDrop" on:click={handleClickInsideYearDropDown}>
            <span class:PlaceholderCls={isYearPlaceholder}> {yearPlaceholder}</span>
          </div>
          {#if openYearDropDown}
            <span class="carBrandDownDropList">
              <input
                id="yearDownDropInput"
                type="text"
                placeholder={QuickSearch}
                class="brandClsInput"
                on:input={e => filteryear(e)}
              />
              <ul class="dropdown-options">
                <li>{Year}</li>
                {#each filteredYear as option}
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <li on:click={() => handleYearSelect(option)}>{option}</li>
                {/each}
              </ul>
            </span>
          {/if}
        </div>
      </Cell>
    </LayoutGrid>
    <LayoutGrid>
      <Cell spanDevices={{ desktop: 12, tablet: 8, phone: 4 }}>
        <div class="inputHeading">{PlateNumber}</div>
        <div>
          <input
            type="text"
            id="PlateNumber"
            class="drownDown"
            name="PlateNumber"
            bind:value={$rsaPlateNo}
            placeholder={PlateNumberPlaceholder}
            on:keyup={validatePlateNo}
            maxlength={15}
          />
        </div>
      </Cell>
    </LayoutGrid>
  </section>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .rsa-detail-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    @include desktop-max-width {
      padding: 0 16px;
      margin-bottom: 48px;
    }

    .carBrandDownDropList {
      background-color: $primary-white;
      border: 1px solid $neutral-light-05;
      display: block;
      max-height: 24rem;
      overflow-x: hidden;
      overflow-y: scroll;
      position: absolute;
      width: 100%;
      z-index: 50;
    }
    .inputfield {
      position: relative;
      cursor: pointer;
    }
    .brandClsInput {
      border: 1px solid $secondary-gray-03;
      border-radius: 0.2rem;
      box-shadow: none;
      font-size: 1.4rem;
      outline: 0;
      padding: 1rem 1.5rem 1rem;
    }
    .dropdown-options li {
      cursor: pointer;
      font-size: 1.3rem;
      line-height: 1.5rem;
      padding: 0.8rem 1.3rem;
      position: relative;
      word-wrap: break-word;
    }
    .brandClsDiv {
      height: 48px;
      width: 100%;
      border: 1px solid $neutral-dark-05;
      border-radius: 8px;
      padding: 16px;
    }
    .rsa_icon {
      position: absolute;
      font-size: 24px;
      color: $icon-only-icon-blue;
      top: 12px;
      right: 16px;
    }
    .drownDown {
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      appearance: none;
      height: 48px;
      width: 100%;
      padding: 16px;
      border: 1px solid $neutral-dark-05;
      border-radius: 8px;
    }
    .inputfield {
      &-select {
        position: relative;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        &:after {
          content: '\e908';
          font-family: 'icon-font';
          color: $tertiary-blue-02;
          right: 18px;
          height: 48px;
          padding: 10px 0px 0px 8px;
          position: absolute;
          pointer-events: none;
          font-size: 20px;
          top: 4px;
          text-shadow:
            0 0 1px currentColor,
            0 0 1px currentColor;
        }
      }
    }
    select:invalid {
      color: $secondary-gray-01;
    }

    input::-webkit-input-placeholder {
      color: $secondary-gray-01;
    }
    .rsa-detail-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 18px;
      margin: 0;
      color: $neutral-dark-01;
    }
    .inputHeading {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: $neutral-dark-03;
      margin-bottom: 8px;
    }
    .PlaceholderCls {
      color: $secondary-gray-01;
    }
    :global {
      .mdc-text-field--outlined,
      .mdc-menu-surface--anchor {
        width: 100%;
      }
      .mdc-floating-label,
      .mdc-floating-label--float-above {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: $neutral-dark-04;
      }
      .mdc-layout-grid {
        padding: 0;
        margin: 0;
      }
    }
  }
</style>
